
      // Check if the animation has already been shown
      if (!localStorage.getItem("animationShown")) {
        // Show the animation
		$('.sitelogo').removeClass('smallactive');
        $('#MainContent').removeClass('no_top_margin');
        $("#animation-box")
          .fadeIn(1000)
          .animate({ width: "200px", height: "200px" }, 1000)
          .fadeOut(1000, function () {
            // Mark the animation as shown in localStorage
            localStorage.setItem("animationShown", "true");
          });
      $("header-section").removeClass("dark_header");

      } else {
        $('.sitelogo').addClass('smallactive');
        $('#MainContent').addClass('no_top_margin');
        $('.sitelogo').addClass('smallactive');
        $("header-section").addClass("dark_header");
      }


$(window).scroll(function() {    
  /*
    var scroll = $(window).scrollTop();
    var wheight = $(window).height();
    if (scroll >= wheight) {
      $("header-section").addClass("show_toplogo");      
    } else {
      $("header-section").removeClass("show_toplogo");
    }*/

  if (scroll <= 20) {
        $(".social-float-parent").removeClass("fix_logo").addClass("fix_logo");
    }
  
});